import { useParams } from "react-router-dom";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import { AuthConsumer } from "./AuthProvider";

export const Login = () => {
    let { emailAddress, redirectUrl } = useParams<{ emailAddress: string, redirectUrl: string }>();

    return <AuthConsumer>
            {({ signinRedirect }) => {
                var decodedUrl = decodeURIComponent(redirectUrl);
                signinRedirect(emailAddress, decodedUrl);
                return <AbpnSpinner/>;
            }}
        </AuthConsumer>

}